import { memo } from 'react';

import { FormIcon } from '@air/design-icons';

export const EmptyAssetCustomFields = memo(() => (
  <div className="flex h-full flex-col items-center justify-center gap-4 p-4">
    <FormIcon className="size-[72px] ads:text-icon-subtle text-gray-7" />
    <p className="font-medium ads:text-metadata text-20 text-gray-8">No custom fields</p>
    <p className="text-center ads:text-metadata text-14 text-gray-8">
      Start applying fields to assets by creating custom fields
    </p>
  </div>
));

EmptyAssetCustomFields.displayName = 'EmptyAssetCustomFields';
